import { render, staticRenderFns } from "./FallSilence.vue?vue&type=template&id=04ad0322&scoped=true&"
import script from "./FallSilence.vue?vue&type=script&lang=js&"
export * from "./FallSilence.vue?vue&type=script&lang=js&"
import style0 from "./FallSilence.vue?vue&type=style&index=0&id=04ad0322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad0322",
  null
  
)

export default component.exports